import { supabase } from '../lib/supabase';

/**
 * Service for managing user approval workflow
 */
class UserApprovalService {
  /**
   * Get all pending approval requests
   */
  async getPendingApprovals() {
    try {
      const { data, error } = await supabase?.from('user_approval_requests')?.select(`
          *,
          user_profiles:user_id (
            id,
            email,
            full_name,
            role,
            phone,
            created_at,
            approval_status
          )
        `)?.eq('admin_notified', false)?.order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching pending approvals:', error);
      throw error;
    }
  }

  /**
   * Get all approval requests (pending, approved, rejected)
   */
  async getAllApprovalRequests() {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.select(`
          id,
          email,
          full_name,
          role,
          phone,
          approval_status,
          approved_by,
          approved_at,
          rejection_reason,
          created_at
        `)?.order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching all approval requests:', error);
      throw error;
    }
  }

  /**
   * Approve a user
   */
  async approveUser(userId, adminId) {
    try {
      const { error } = await supabase?.rpc('approve_user', {
        p_user_id: userId,
        p_admin_id: adminId
      });

      if (error) throw error;
      return { success: true };
    } catch (error) {
      console.error('Error approving user:', error);
      throw error;
    }
  }

  /**
   * Reject a user
   */
  async rejectUser(userId, adminId, reason) {
    try {
      const { error } = await supabase?.rpc('reject_user', {
        p_user_id: userId,
        p_admin_id: adminId,
        p_reason: reason
      });

      if (error) throw error;
      return { success: true };
    } catch (error) {
      console.error('Error rejecting user:', error);
      throw error;
    }
  }

  /**
   * Send admin approval notification via Edge Function
   */
  async sendAdminNotification(userEmail, userName, userRole, userId) {
    try {
      const { data, error } = await supabase?.functions?.invoke(
        'send-admin-approval-notification',
        {
          body: {
            userEmail,
            userName,
            userRole,
            userId
          }
        }
      );

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error sending admin notification:', error);
      throw error;
    }
  }
}

export default new UserApprovalService();